import { NEXT_PROJECT_BUTTON } from '../../core/constants';
import { translate } from '../../core/i18n';
import { store } from '../../core/state';
import { FloatableButton } from './base/FloatableButton';
import ModernHeaderButton from './base/ModernHeaderButton';

export const NextProjectButton = (props) => {
  const [attentionOnButton, setAttentionOnButton] = store.useState(NEXT_PROJECT_BUTTON+"attention", { default : false });
  const [hadAttention, setHadAttention] = store.useState(NEXT_PROJECT_BUTTON+"hadattention", { default : false });

  let tippyPlacement = props.floating ? "left" : "bottom";
  const title = translate("next-button-title");
  const content = translate("next-button-content");

  const clicked = () => {
    props.nextProjectRequested();
  }

  if (props.show && !attentionOnButton && !hadAttention) {
    setAttentionOnButton(true);

    setTimeout(() => {
      setAttentionOnButton(false);
      setHadAttention(true);
    }, 1000);
  }

  return (
    <FloatableButton tippyContent={content} tippy={true} floating={props.floating} attention={attentionOnButton} tippyPlacement={tippyPlacement}>
      <ModernHeaderButton icon="arrow-right" onClick={clicked} title={title} text={title} variant={'primary'} />
    </FloatableButton>
  );
}